import party from '../views/party'

export default {
  path: '/party',
  component: party,
  redirect: '/party/member',
  name: 'Party',
  meta: { title: '党建管理' },
  children: [
    {
      path: '/party/member',
      component: () => import('@/views/party/Member'),
      name: 'Member',
      meta: { title: '分类管理' }
    },
    {
      path: '/party/goods',
      component: () => import('@/views/party/Goods'),
      name: 'Goods',
      meta: { title: '产品管理' }
    },
    {
      path: '/party/notice',
      component: () => import('@/views/party/Notice'),
      name: 'Notice',
      meta: { title: '轮播图管理' }
    }
  ]
}
